import { useHistory } from 'react-router-dom';
import { useRef, useState } from 'react';
import { AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ModelOfProductBrand } from '../../database/index';

import api from '../../services/api';

import { useAuth } from 'src/contexts/auth';

export const useFormCreateProductBrands = () => {
	const [loading, setLoading] = useState<boolean>(false);
	const [ProductbrandResponse, setProductBrandResponse] = useState<AxiosResponse | null>(null);
	const [ProductbrandEditedResponse, setProductBrandEditedResponse] = useState<AxiosResponse | null>(null);
	const history = useHistory();

	const toast: any = useRef();

	const { userAgencyId } = useAuth();

	const validationSchema = Yup.object().shape({
		DESCRICAO: Yup.string().required('* Campo obrigatório'),
	});

	const saveProductBrand = async (Productbrand: ModelOfProductBrand) => {
		setLoading(true);

		const newProductBrand: ModelOfProductBrand = {
			...Productbrand,
		};

		console.log("Marca: ", newProductBrand)

		if (!!ProductbrandResponse) {
			api.put(`products-brands/${ProductbrandResponse.data.ID}`, newProductBrand)
				.then(response => {
					formik.resetForm();
					setProductBrandEditedResponse(response);
					setProductBrandResponse(null);
					setLoading(false);
					toast.current.show({
						severity: 'success',
						summary: 'Edição realizada',
						detail: 'A marca foi editada com sucesso!',
						life: 5000,
					});
				})
				.catch(err => {
					console.log(err);
					setLoading(false);
					toast.current.show({
						severity: 'error',
						summary: 'Edição não realizado',
						detail: 'Falha ao realizar operação!',
						life: 5000,
					});
				});
		} else {
			console.log("userAgencyId ",userAgencyId)
			console.log("newProductBrand ",newProductBrand)
			api.post(`products-brands/${userAgencyId}`, newProductBrand)
				.then(response => {
					if (window.location.href === '/ProductbrandForm') history.push('/listProductBrands');
					setLoading(false);
					setProductBrandResponse(response);
					setProductBrandEditedResponse(null);
					toast.current.show({
						severity: 'success',
						summary: 'Cadastro realizado',
						detail: 'Operação realizada com sucesso!',
						life: 5000,
					});
				})
				.catch(err => {
					setLoading(false);
					toast.current.show({
						severity: 'error',
						summary: 'Cadastro não realizado',
						detail: 'Falha ao realizar operação!' + err,
						life: 5000,
					});
				});
		}
	};

	const formik = useFormik<ModelOfProductBrand>({
		initialValues: {
			DESCRICAO: '',
		},
		onSubmit: async values => await saveProductBrand(values),
		validationSchema,
	});

	return {
		getProductBrandFormController: {
			formik,
			loading,
			toast,
			ProductbrandResponse,
			ProductbrandEditedResponse,
		},
		handleProductBrandFormController: {
			setProductBrandResponse,
		},
	};
};
